import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";
import { AppRoutes } from "../../../../common/routes/app_routes";
import { Heading, Text } from "../../../../components/common/typography";
import AuthBrandPanel from "../components/auth-brand-panel";
import { VerifyResetOtpForm } from "../components/verify_reset_otp_form";

type LocationState = { email?: string } | null;

const VerifyResetOtpPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = (location.state as LocationState)?.email ?? "";

  useEffect(() => {
    if (!email) navigate(AppRoutes.FORGOT_PASSWORD, { replace: true });
  }, [email, navigate]);

  if (!email) return null;

  return (
    <main className="flex min-h-screen w-full bg-bgWhite">
      <div className="sticky top-0 hidden h-screen w-1/2 shrink-0 lg:block">
        <AuthBrandPanel />
      </div>

      <section className="flex min-h-screen flex-1 flex-col px-6 sm:px-12">
        <div className="pt-6">
          <button
            type="button"
            onClick={() => navigate(AppRoutes.FORGOT_PASSWORD)}
            aria-label="Back"
            className="flex items-center justify-center text-textBody transition-colors hover:text-textDark"
          >
            <IconArrowLeft size={22} />
          </button>
        </div>

        <div className="flex flex-1 items-center justify-center pb-48">
          <div className="flex w-full max-w-[528px] flex-col items-center gap-8">
            <div className="flex flex-col items-center gap-6 text-center">
              <Heading variant="h2" tone="dark">Verify email address</Heading>
              <Text variant="body" tone="body" className="max-w-lg">
                To verify your email, we sent you a One Time Password to{" "}
                <Text variant="bodyBold" tone="dark" inline>{email}</Text>
              </Text>
            </div>

            <div className="w-full">
              <VerifyResetOtpForm email={email} />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default VerifyResetOtpPage;
